import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  pure: false
})

export class SortPipeService {

  transform(array, sort, asc = true) {console.log(array+sort+asc);

    if (array != undefined) {
      if (!sort || sort.trim() == "") {
        return array;
      }

      //ascending
      if (asc) {
        return Array.from(array).sort((item1: any, item2: any) => {
          return this.orderByComparator(item1[sort], item2[sort]);
        });
      }
      else {
        //not asc
        return Array.from(array).sort((item1: any, item2: any) => {
          return this.orderByComparator(item2[sort], item1[sort]);
        });
      }
    }


  }

  orderByComparator(a: any, b: any): number {
    if (a == '' || a == null) a = 0;
    if (b == '' || b == null) b = 0;
    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
      //Isn't a number so lowercase the string to properly compare
      if (a.toString().toLowerCase() < b.toString().toLowerCase()) return -1;
      if (a.toString().toLowerCase() > b.toString().toLowerCase()) return 1;
    }
    else {
      //Parse strings as numbers to compare properly
      if (parseFloat(a) < parseFloat(b)) return -1;
      if (parseFloat(a) > parseFloat(b)) return 1;
    }

    return 0; //equal each other
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/sort-pipe.service.ts